// Placeholder event bus: fires into Meta Pixel, Google gtag and dataLayer
// whenever those scripts are configured in public/index.html.
export const track = (event, params = {}) => {
  if (typeof window === "undefined") return;
  try {
    if (typeof window.fbq === "function") window.fbq("trackCustom", event, params);
    if (typeof window.gtag === "function") window.gtag("event", event, params);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
  } catch (e) {
    /* tracking must never break UX */
  }
};
